import { Component } from '@angular/core'

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  sponsorStripSrc = 'assets/brand/lista-vermelha/patrocinadores/regua-patrocinadores-nova-adaptada.png'
}
